module.exports = __webpack_public_path__ + "static/media/LinkedInBug.a6dab744.png";